const LocalStorageKey = {
    ACCESS_TOKEN: "ACCESS_TOKEN"
}

export default LocalStorageKey;